import React from 'react';
import { ChakraProvider, Box, extendTheme } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { BoardSidebar } from './components/BoardSidebar';
import { CommitteeSidebar } from './components/CommitteeSidebar';
import { WelcomePage } from './pages/WelcomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ForgotPage } from './pages/ForgotPage';
import { BoardPage } from './pages/BoardPage';
import { CommitteePage } from './pages/CommitteePage';
import { AccountPage } from './pages/AccountPage';
import { ToastPage } from './pages/ToastPage';
import { Toaster } from 'sonner';
import { BoardProvider } from './context/BoardContext';
import { CommitteeProvider } from './context/CommitteeContext';
const theme = extendTheme({
  fonts: {
    heading: `'Roboto', sans-serif`,
    body: `'Roboto', sans-serif`
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: '#333'
      }
    }
  },
  components: {
    Radio: {
      baseStyle: {
        control: {
          borderColor: '#00897B',
          _checked: {
            bg: '#00897B',
            borderColor: '#00897B',
            _hover: {
              bg: '#00695C',
              borderColor: '#00695C'
            }
          },
          _hover: {
            borderColor: '#00695C'
          }
        }
      }
    }
  }
});
/** Welcome layout: original nav sidebar */
function WelcomeLayout() {
  return <Box w="100vw" h="100vh" overflow="hidden" position="relative" data-id="element-0">
      <Header data-id="element-1" />
      <Sidebar data-id="element-2" />
      <Box position="fixed" top="64px" left="290px" right={0} bottom={0} bg="white" overflowY="auto" data-id="element-3">
        <Outlet data-id="element-4" />
      </Box>
    </Box>;
}
/** Board layout: board member sidebar */
function BoardLayout() {
  return <BoardProvider data-id="element-5">
      <Box w="100vw" h="100vh" overflow="hidden" position="relative" data-id="element-6">
        <Header data-id="element-7" />
        <BoardSidebar data-id="element-8" />
        <Box position="fixed" top="64px" left="290px" right={0} bottom={0} bg="white" overflowY="auto" data-id="element-9">
          <Outlet data-id="element-10" />
        </Box>
      </Box>
    </BoardProvider>;
}
/** Committee layout: committee member sidebar */
function CommitteeLayout() {
  return <Box w="100vw" h="100vh" overflow="hidden" position="relative" data-id="element-11">
      <Header data-id="element-12" />
      <CommitteeSidebar data-id="element-13" />
      <Box position="fixed" top="64px" left="290px" right={0} bottom={0} bg="white" overflowY="auto" data-id="element-14">
        <Outlet data-id="element-15" />
      </Box>
    </Box>;
}
export function App() {
  return <ChakraProvider theme={theme} data-id="element-16">
      <BrowserRouter data-id="element-17">
        <CommitteeProvider data-id="element-18">
          <Toaster position="top-right" richColors expand={false} closeButton data-id="element-19" />
          <Routes data-id="element-20">
            <Route path="/" element={<Navigate to="/login" replace data-id="element-22" />} data-id="element-21" />
            <Route path="/login" element={<LoginPage data-id="element-24" />} data-id="element-23" />
            <Route path="/register" element={<RegisterPage data-id="element-26" />} data-id="element-25" />
            <Route path="/thankyou" element={<ThankYouPage data-id="element-28" />} data-id="element-27" />
            <Route path="/forgot" element={<ForgotPage data-id="element-30" />} data-id="element-29" />
            <Route path="/account" element={<AccountPage data-id="element-32" />} data-id="element-31" />

            <Route element={<WelcomeLayout data-id="element-34" />} data-id="element-33">
              <Route path="/welcome" element={<WelcomePage data-id="element-36" />} data-id="element-35" />
              <Route path="/toast" element={<ToastPage data-id="element-38" />} data-id="element-37" />
            </Route>

            <Route element={<BoardLayout data-id="element-40" />} data-id="element-39">
              <Route path="/board" element={<BoardPage data-id="element-42" />} data-id="element-41" />
            </Route>

            <Route element={<CommitteeLayout data-id="element-44" />} data-id="element-43">
              <Route path="/committee" element={<CommitteePage data-id="element-46" />} data-id="element-45" />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace data-id="element-48" />} data-id="element-47" />
          </Routes>
        </CommitteeProvider>
      </BrowserRouter>
    </ChakraProvider>;
}